import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AirportComment } from '../models/airport-comment.model';
import { RemarkService } from '../service/remark.service';


@Component({
  selector: 'app-edit-remark',
  templateUrl: './edit-remark.component.html',
  styleUrls: ['./edit-remark.component.scss']
})
export class EditRemarkComponent implements OnInit {
  remark: AirportComment;
  originalRemark: AirportComment;
  isNew = false;
  isLoading = false;
  airportID: number;
  itemsToChange: Set<number>;
  formGroup: FormGroup;
  remarkType: string;
  remarkRef: string;
  selectedText: string;
  windowTitle = 'Remark';

  constructor(private _matDialogRef: MatDialogRef<EditRemarkComponent>,
              public _snackBar: MatSnackBar,
              @Inject(MAT_DIALOG_DATA) data,
              private _remarkService: RemarkService) {
    this.remark = data.remark || new AirportComment();
    this.isNew = data.isNew || false;
    this.airportID = data.airID;
    this.originalRemark = Object.assign(new AirportComment(), data.remark);
    this.itemsToChange = new Set<number> ();
    this.remarkType = AirportComment.formatCommentType(this.remark.commentType);
    this.remarkRef = this.remark.commentRef;
    this.selectedText = this.remark.text ? this.remark.text : '';
    this.windowTitle = data.windowTitle || 'Remark';
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
    this.formGroup = new FormGroup({
      text: new FormControl(this.selectedText, [Validators.required, Validators.maxLength(1000)])
    });
  }

  /**
   * triggered by save button click event
   * @return {Promise<void>}
   */
  async save() {
    try {
      let res: any;
      this.remark.commentType = AirportComment.parseCommentType(this.remarkType);
      this.remark.commentRef = this.remarkRef;
      this.remark.text = this.formGroup.get('text').value;
      if (this.isNew) {
        res = await this._remarkService.postRemark(this.airportID, this.remark);
        this.remark = AirportComment.parse(res);
      } else {
        res = await this._remarkService.putRemark(this.airportID, this.remark);
        Object.assign(this.remark, AirportComment.parse(res));
        this.remark = AirportComment.parse(res);
      }
      this.close({cancelBtnClicked: false, success: true, remark: this.remark});
    } catch (e) {
      this.close({cancelBtnClicked: false, success: false});
    }
  }

  /**
   * triggered by cancel button click event
   */
  cancel () {
    this.close({cancelBtnClicked: true});
  }

  /**
   * closes modal
   * @param data
   */
  close(data: any) {
    if (data && data.cancelBtnClicked) {
      Object.assign(this.remark, this.originalRemark);
    }
    data['isNew'] = this.isNew;
    this._matDialogRef.close(data);
  }
}
